const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '免税购乐帮',
      hideNavbarAction: true
    },
    component: () => import('@/views/home')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/login')
  },
  {
    path: '/find',
    name: 'find',
    meta: {
      title: '发现'
    },
    component: () => import('@/views/find')
  },
  {
    path: '/find/page',
    name: 'findPage',
    meta: {
      title: '发现页',
      hideNavbarAction: true
    },
    component: () => import('@/views/find/page')
  },
  {
    path: '/lottery/shop',
    name: 'shopLottery',
    meta: {
      title: '福利彩票券',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/lottery/shop')
  },
  {
    path: '/lottery/notice',
    name: 'noticeLottery',
    meta: {
      title: '开奖公告',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/lottery/notice')
  },
  {
    path: '/lottery/exchange',
    name: 'exchangeLottery',
    meta: {
      // title: '兑换码领取',
      title: '福袋券兑换',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/lottery/exchange')
  },
  {
    path: '/lottery/detail',
    name: 'lotteryDetail',
    meta: {
      keepAlive: true,
      title: '优惠券'
    },
    component: () => import('@/views/lottery/detail')
  },
  {
    path: '/lottery/receive',
    name: 'receiveView',
    meta: {
      keepAlive: true,
      title: '奖金派发账户'
    },
    component: () => import('@/views/lottery/receive')
  },
  {
    path: '/lottery/issueTicket',
    name: 'issueTicketView',
    meta: {
      keepAlive: true,
      title: '出票中'
    },
    component: () => import('@/views/lottery/issueTicket')
  },
  {
    path: '/lottery/bankCard',
    name: 'bankCardView',
    meta: {
      keepAlive: true,
      title: '银行卡'
    },
    component: () => import('@/views/lottery/bankCard')
  },
  {
    path: '/coupons/card',
    name: 'couponsCard',
    meta: {
      title: '日上会员',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/coupons/card')
  },
  {
    path: '/article/cy/privacy',
    name: 'cyPrivacyView',
    meta: {
      title: '隐私协议政策',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/article/cy/privacy')
  },
  {
    path: '/article/cy/auth',
    name: 'cyAuthView',
    meta: {
      title: '移动用户授权协议',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/article/cy/auth')
  },
  {
    path: '/activity/lottery/index',
    name: 'activityLotteryIndex',
    meta: {
      title: '积分换彩',
      // keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/activity/lottery/index')
  },
  {
    path: '/activity/lottery/main',
    name: 'activityLotteryMain',
    meta: {
      title: '福利积分兑换',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/activity/lottery/main')
  },
  {
    path: '/activity/lottery/bind',
    name: 'activityLotteryBind',
    meta: {
      title: '绑定畅游平台账户',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/activity/lottery/bind')
  },
  {
    path: '/activity/lottery/result',
    name: 'activityLotteryResult',
    meta: {
      title: '兑换成功',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/activity/lottery/result')
  },
  {
    path: '/activity/lottery/list',
    name: 'activityLotteryList',
    meta: {
      title: '我的兑换',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/activity/lottery/list')
  },
  {
    path: '/activity/lottery/detail',
    name: 'activityLotteryDetail',
    meta: {
      title: '兑换详情',
      keepAlive: true,
      hideNavbarAction: true
    },
    component: () => import('@/views/activity/lottery/detail')
  },
  {
    path: '/tool/link',
    name: 'toolLink',
    meta: {
      title: '美国运通卡礼遇',
      hideNavbarAction: true
    },
    component: () => import('@/views/tool/link')
  },
  {
    path: '/webview',
    name: 'webview',
    meta: {
      title: '免税购乐帮'
    },
    component: () => import('@/views/webview')
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default routes
